import React from 'react';
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import { SingleAttachmentInputFormField } from '../../../../components/SingleAttachmentInputFormField';

interface PropTypes {
  referral?: boolean;
  formRegister: UseFormRegister<CandidateDto>;
  getValues: UseFormGetValues<CandidateDto>;
  setValue: UseFormSetValue<CandidateDto>;
  captionText?: string;
}

export function CandidateResumeInput(props: PropTypes) {
  return (
    <Row>
      <Col xs={6}>
        <SingleAttachmentInputFormField<CandidateDto>
          getValues={props.getValues}
          setValue={props.setValue}
          formRegister={props.formRegister}
          headerClassNames='fw-semibold'
          controllerContentName='resume.content'
          controllerFileName='resume.filename'
          controllerIdName='resume.id'
          fieldName={'Resume / Curriculum Vitae'}
          allowedFormats={['.pdf', '.doc', '.docx']}
          maxFileSizeMb={10}
          isRequired={false}
          disabled={false}
          hideAlert={true}
        />
        {props.captionText && (
          <small className='text-muted'>{props.captionText}</small>
        )}
      </Col>
    </Row>
  );
}
